import { FormGroup, FormGroupFeedback, Intent } from '@pinpointhq/thumbtack';
import * as React from 'react';
import Select from 'react-select';
import IReactSelectOption from '../../interfaces/IReactSelectOption';
import toSentence from '../utilities/toSentence';

interface ISelectFieldProps {
  attributeName?: string;
  inputId?: string;
  initialErrors?: string[];
  name: string;
  options: { value: number | string; label: string }[];
  placeholder?: string;
  storedOption?: number | string;
  useMobileSelect?: boolean;
  handleSelect?(option): void;
}

export default function SelectField(props: ISelectFieldProps) {
  const {
    attributeName,
    handleSelect,
    inputId,
    initialErrors = [],
    name,
    options,
    placeholder = 'Select...',
    storedOption,
    useMobileSelect = false,
  } = props;
  const [errors, setErrors] = React.useState<string[]>(initialErrors);

  const [selectedOption, setSelectedOption] = React.useState<typeof options[number]>();

  React.useEffect(() => {
    if (storedOption) {
      setSelectedOption(options.find((option) => option.value === storedOption));
    }
  }, [options, storedOption]);

  function handleChange(selectedItems) {
    setErrors([]);
    setSelectedOption(selectedItems);
    if (handleSelect) handleSelect(selectedItems);
  }

  const handleMobileChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedOption = options.find((option) => option.value === event.target.value);
    setSelectedOption(selectedOption);
    if (handleSelect) handleSelect(selectedOption);
  };

  function selectName(index) {
    if (!attributeName) return name;

    return `${name}[${index}][${attributeName}]`;
  }
  return (
    <>
      <Select
        isClearable={true}
        value={selectedOption}
        options={options}
        name={attributeName ? 'selectBox' : name}
        inputId={inputId || name}
        className={`react-select ${useMobileSelect ? 'hide-sm-block' : ''} ${
          errors.length > 0 ? 'react-select--error' : ''
        }`}
        classNamePrefix="react-select"
        isSearchable={true}
        closeMenuOnSelect={true}
        onChange={handleChange}
        placeholder={placeholder}
      />
      <select
        className="hide-at-sm-block"
        value={selectedOption?.value}
        onChange={handleMobileChange}
        id={inputId || name}
      >
        <option value="blank">Select...</option>
        {options.map((option: IReactSelectOption) => {
          return (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          );
        })}
      </select>
      {errors.length > 0 && (
        <FormGroup>
          <FormGroupFeedback intent={Intent.DANGER}>{toSentence(initialErrors)}</FormGroupFeedback>
        </FormGroup>
      )}
      {attributeName && selectedOption && <input type="hidden" name={selectName(0)} value={selectedOption.value} />}
    </>
  );
}
